import React, { useState, useEffect } from 'react';
import Exterior from './SVG/Exterior';
import Button from '../Button';
import Icon from '../Icon';
import Interior from './SVG/Interior';
import Seguridad from './SVG/Seguridad';
import Capacidad from './SVG/Capacidad';
import bem from '../../utils/bem';

const Feature = ({ children, featureChange, id, version, currentTab, description }) => {
  const exists = !!version[id];
  if (!exists) {
    return null;
  }
  return (
      <>
        <button onClick={() => featureChange(id)} className={exists && currentTab === id ? 'active': ''}>
            <span>
              {children}
            </span>
        </button>
        {currentTab === id && 
          <div className="version-options--items-item__info-features mobile" dangerouslySetInnerHTML={{
            __html: description,
          }} 
        />}
      </>
  );
};

const VersionDetails = ({ version, scroll, setSelectedVersion, onClickDetail }) => {
  const [currentTab, setCurrentTab] = useState(null);

  useEffect(() => {
    let tab = null;
    if (!!version?.caracteristicasExteriores) {
      tab = 'caracteristicasExteriores';
    } else if (!!version?.caracteristicasInterior) {
      tab = 'caracteristicasInterior';
    } else if (!!version?.caracteristicasSeguridad) {
      tab = 'caracteristicasSeguridad';
    } else if (!!version?.caracteristicasCapacidad) {
        tab = 'caracteristicasCapacidad';
    }
  setCurrentTab(tab);
  }, [version.caracteristicasCapacidad, version.caracteristicasExteriores, version.caracteristicasInterior, version.caracteristicasSeguridad]);
  
  const exists = () => {
    if (!currentTab) {
      return false;
    }
    const exists = version[currentTab];
    return !!exists;
  }
  
  const description = () => {
    if (!exists()) {
      return null;
    } 
    return version[currentTab];
  }

  const featureChange = (type) => {
    setCurrentTab(type);
    onClickDetail();
};
  return (
    <div className={bem('version-options--items-item__info', {
      hidden: !exists()
    })} >
      <h6>CONOCÉ MÁS</h6>
      <p>{version.descLarga}</p>
      <h6 className="caracs">Características</h6>
      <div className="version-options--items-item__info-listing">
          <Feature featureChange={featureChange} version={version} id="caracteristicasExteriores" currentTab={currentTab} description={description()}>
              <Exterior />
              Exteriores
          </Feature>
          <Feature featureChange={featureChange} version={version} id="caracteristicasInterior" currentTab={currentTab} description={description()}>
              <Interior />
              Interiores
          </Feature>
          <Feature featureChange={featureChange} version={version} id="caracteristicasSeguridad" currentTab={currentTab} description={description()}>
              <Seguridad />
              Seguridad
          </Feature>
          <Feature featureChange={featureChange} version={version} id="caracteristicasCapacidad" currentTab={currentTab} description={description()}>
              <Capacidad />
              Técnicas y Capacidad 
          </Feature>
      </div>
      <div className="version-options--items-item__info-features desktop" dangerouslySetInnerHTML={{
          __html: description(),
          }} 
      />
      <div className="version-options--items-item__info-hide-info">
          <Button 
              supernaked
              onClick={() => { 
                  scroll('.version-options--items', 90, 'smooth');
                  setSelectedVersion(null);
              }} 
              ui="circular">
              Ocultar Información <Icon type="down-arrow" />
          </Button>
      </div>
  </div>
  )
};

export default VersionDetails;